










import {Component, Vue} from 'vue-property-decorator';
import Search from "../components/Search.vue";
import Results from "../components/Results.vue";
import TmDetails from "../components/TmDetails.vue";
import store from '../core/store'

@Component({
  components: {
    Search,
    TmDetails,
    Results
  },
})
export default class Home extends Vue {

  get hasResults() {
    return store.state.matchResult;
  }

}
